// Domain models
export type Role = 'user' | 'admin' | 'system';

export interface ChatMessage {
  id: string;
  role: Role;
  content: string;
  createdAt: Date;
  attachments?: string[];
  meta?: Record<string, unknown>;
}

export interface Conversation {
  id: string;
  title: string;
  messages: ChatMessage[];
  createdAt: Date;
  updatedAt: Date;
  clientId?: string;
  agentId?: string;
  archived?: boolean;
  retryAttempts?: number;
}

// Factory helpers (centralized construction logic)
export function createChatMessage(partial: {
  id?: string;
  role: Role;
  content?: string;
  attachments?: string[];
  meta?: Record<string, unknown>;
  createdAt?: Date;
}): ChatMessage {
  return {
    id: partial.id || `${partial.role}-${Date.now()}-${Math.random().toString(36).slice(2,8)}`,
    role: partial.role,
    content: partial.content ?? '',
    createdAt: partial.createdAt || new Date(),
    attachments: partial.attachments,
    meta: partial.meta,
  };
}

export function createConversation(partial: {
  id: string;
  title?: string;
  messages?: ChatMessage[];
  createdAt?: Date;
  updatedAt?: Date;
  clientId?: string;
  agentId?: string;
}): Conversation {
  const now = new Date();
  return {
    id: partial.id,
    title: partial.title ?? 'New Conversation',
    messages: partial.messages ?? [],
    createdAt: partial.createdAt || now,
    updatedAt: partial.updatedAt || now,
    clientId: partial.clientId,
    agentId: partial.agentId,
    archived: false,
    retryAttempts: 0,
  };
}

export interface Client {
  id: string;
  name: string;
  description?: string;
  policyVersion?: string;
}

export interface AgentTopic {
  id: string;
  name: string; // e.g. PTO, Overtime, Vacation
  systemPrompt: string;
  description?: string;
}

export interface JsonConfigDraft {
  id: string;
  original: unknown;
  transformed?: unknown;
  clientId?: string;
  validated: boolean;
  updatedAt: Date;
}
